module.exports = __webpack_public_path__ + "static/media/react1Form2.19ccc07e.png";